import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "../GraderUI";

export default function ErrorState({ message, onRetry }) {
	return (
		<div className="aeo-grader-report">
			<div className="error-state">
				<motion.div
					className="error-state__panel"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
				>
					<div className="error-state__icon-wrap">
						<AlertTriangle className="error-state__icon" />
					</div>
					<h2 className="error-state__title">Unable to Load Report</h2>
					<p className="error-state__message">
						{message || "There was an error loading the audit report. Please try again."}
					</p>
					{onRetry && (
						<Button className="error-state__retry" onClick={onRetry}>
							<RefreshCw size={16} />
							Retry
						</Button>
					)}
				</motion.div>
			</div>
		</div>
	);
}
